import type { ComponentProps, DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { useField } from '@michaelgmcd/rvf';

type HiddenInputComponentProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  name: string;
};

export const HiddenInput = (props: HiddenInputComponentProps) => {
  const { getInputProps } = useField(props.name);

  return <input {...getInputProps({ ...props, type: 'hidden', hidden: true })} />;
};

export type HiddenInputProps = ComponentProps<typeof HiddenInput>;
